import React from 'react';
import { Button } from '@mui/material';
import { Connector } from '@domain/connection/models/Connector';
import { APP_CONFIG } from '../../../../config/app.config';

interface MarketplaceConnectorButtonProps {
  connector: Connector;
  onClick: (connector: Connector) => void;
}

const MarketplaceConnectorButton: React.FC<MarketplaceConnectorButtonProps> = ({
  connector: connector,
  onClick,
}) => {
  const colors = APP_CONFIG.ui.theme.colors;

  return (
    <Button
      variant="outlined"
      sx={{
        p: 1,
        width: '100%',
        height: '100%',
        minHeight: 88,
        borderColor: colors.border,
        borderRadius: '6px',
        bgcolor: 'background.paper',
        '&:hover': {
          borderColor: colors.primary,
          bgcolor: colors.backgroundTint,
        },
      }}
      onClick={() => onClick(connector)}
    >
      <img
        src={connector.image}
        alt={connector.type}
        style={{ width: '100%', height: 'auto', maxHeight: 72, objectFit: 'contain' }}
        onError={(e) => {
          e.currentTarget.src = '/assets/images/ic_just_stock.png';
        }}
      />
    </Button>
  );
};

export default MarketplaceConnectorButton;
